<template>
  <div class="popUpWrap dark">
    <section class="popup dark">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5 v-html="deleteMessage" />
          <p>{{ t('skillCertify-candidate-delete-description', dialogStore.options.props.selectedCandidates.length) }}</p>
        </div>
        <div class="btnArea">
          <button class="cancel" @click.stop="onClickClose">{{ t('common-cancel') }}</button>
          <button @click.stop="onClickRemove">{{ t('common-delete') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from "~/store/dialog/dialogStore";
import {useI18n} from "#imports";

const {$i18n} = useNuxtApp();
const { t } = useI18n();

const dialogStore = useDialogStore();

const deleteMessage = computed(() => {
  if ($i18n.locale.value === 'en' || $i18n.locale.value === 'vi')
    return t('skillCertify-candidate-delete-1') + "<br/>" +
        countWithTag.value + " " +
        t('skillCertify-candidate-delete-2', dialogStore.options.props.selectedCandidates.length);
  else return countWithTag.value + t('skillCertify-candidate-delete-1');
});

const countWithTag = computed(() =>
  `<span class="blue">${dialogStore.options.props.selectedCandidates.length}</span>`
);

const onClickClose = () => {
  dialogStore.close();
}

const onClickRemove = () => {
  dialogStore.options.confirm?.event();
  onClickClose();
}
</script>

